module.exports = __webpack_public_path__ + "img/icone-webhook-dados-historicos.3f6e65ad.svg";